import { Box, Step, StepConnector, StepLabel, Stepper } from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const BRAND_BLUE = "#3655F2";
const COMPLETED_GREEN = "#1B7C4E";
const UPCOMING_GRAY = "#9CA3AF";
const ICON_SIZE = 32;

export type OnboardingStep = {
  id: string;
  label: string;
  shortLabel?: string;
};

const Connector = styled(StepConnector)(({ theme }) => ({
  top: ICON_SIZE / 2,
  left: `calc(-50% + ${ICON_SIZE / 2}px)`,
  right: `calc(50% + ${ICON_SIZE / 2}px)`,
  "& .MuiStepConnector-line": {
    borderColor: theme.palette.divider,
    borderTopWidth: 2,
  },
}));

type StepIconProps = {
  active?: boolean;
  completed?: boolean;
  icon?: React.ReactNode;
};

function StepIcon({ active, completed, icon }: StepIconProps) {
  const base = {
    width: ICON_SIZE,
    height: ICON_SIZE,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    fontSize: 14,
  };
  if (completed) {
    return (
      <Box
        sx={{
          ...base,
          bgcolor: "background.paper",
          border: 2,
          borderColor: COMPLETED_GREEN,
          color: COMPLETED_GREEN,
        }}
      >
        <CheckIcon fontSize="small" />
      </Box>
    );
  }
  if (active) {
    return (
      <Box sx={{ ...base, bgcolor: BRAND_BLUE, color: "#fff" }}>{icon}</Box>
    );
  }
  return (
    <Box
      sx={{
        ...base,
        border: 1,
        borderColor: "divider",
        color: UPCOMING_GRAY,
        bgcolor: "background.paper",
      }}
    >
      {icon}
    </Box>
  );
}

type Props = {
  steps: OnboardingStep[];
  currentStep: number;
};

function OnboardingStepper({ steps, currentStep }: Props) {
  return (
    <Stepper
      activeStep={currentStep}
      alternativeLabel
      connector={<Connector />}
    >
      {steps.map((step) => (
        <Step key={step.id}>
          <StepLabel
            StepIconComponent={StepIcon}
            sx={{
              "& .MuiStepLabel-label": {
                mt: 1,
                fontSize: 11,
                color: UPCOMING_GRAY,
                fontWeight: 500,
              },
              "& .MuiStepLabel-label.Mui-active": {
                color: BRAND_BLUE,
                fontWeight: 700,
              },
              "& .MuiStepLabel-label.Mui-completed": {
                color: COMPLETED_GREEN,
                fontWeight: 600,
              },
            }}
          >
            {step.shortLabel ?? step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

export default OnboardingStepper;
